
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.075 12.382a1 1 0 00.21.33l5 5a1.004 1.004 0 001.42-1.42l-3.3-3.29h7.59a1 1 0 000-2h-7.59l3.3-3.29a1.001 1.001 0 00-.325-1.64 1 1 0 00-1.095.22l-5 5a1 1 0 00-.21.33 1 1 0 000 .76z","fill":"#000"}})])
          )
        }
      }
    